import "./Skills.css";

function Skills() {
  return (
    <div id="skills" className="skill">
      <h1 className="skill_div">SKILLS</h1>
      <div className="icons">
        <img
          src="https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582748_1280.png"
          alt="html5"
        />
        <img
          src="https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582747_960_720.png"
          alt="css3"
        />
        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg"
          alt="javascript"
        />
        <img
          src="https://www.pngitem.com/pimgs/m/520-5202823_nodejs-node-js-logo-png-transparent-png.png"
          alt="node"
        />

        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png"
          alt="react"
        />
        <img
          src="https://avatars.githubusercontent.com/u/13142323?v=4"
          alt="redux"
        />
        <img
          src="https://www.coffeeclass.io/logos/chakra-ui.png"
          alt="chkraui"
        />
        <img
          src="https://cdn.iconscout.com/icon/free/png-128/mongodb-5-1175140.png"
          alt="mango db"
        />
        <img
          src="https://www.bing.com/th?id=OIP.hNJsVigCUtoVEKXErf-uHgHaED&w=338&h=184&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2"
          alt="expressjs"
        />
        <img
          src="https://images-cdn.openxcell.com/wp-content/uploads/2024/07/24154156/dango-inner-2.webp"
          alt="next.js"
        />
      </div>

      <h1 className="tools_div">TOOLS</h1>
      <div className="icons">
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR--TG8CsCWeWP7qMuFz7mZfTfR8U7GqTYmrg&s"
          alt="netlify"
        />
        <img
          src="https://w7.pngwing.com/pngs/436/888/png-transparent-vercel-hd-logo-thumbnail.png"
          alt="vercel"
        />
        <img
          src="https://cdn4.iconfinder.com/data/icons/iconsimple-logotypes/512/github-512.png"
          alt="github"
        />

        <img
          src="https://cdn.iconscout.com/icon/free/png-128/npm-3550843-2970428.png"
          alt="npm"
        />
        <img
          src="https://yt3.googleusercontent.com/XRzDTgEa9GybH_Uk21E9ri6_iYh-9gbyZzhiEBCnLjISgjTorjMiu7IwpChUMf2lLpEdX6ufDA=s900-c-k-c0x00ffffff-no-rj"
          alt="postman"
        />
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png"
          alt="visual code"
        />
      </div>
    </div>
  );
}

export default Skills;
